// components/Stepper.js
import React from "react";
import "./NegoActionStepper.scss";
interface StepperProps {
  currentStep: number;
  goToStep: (index: number) => void;
  totalSteps: number;
}

const NegoActionStepper = ({
  currentStep,
  goToStep,
  totalSteps,
}: StepperProps) => {
  const steps = [];
  for (let i = 0; i < totalSteps; i++) {
    if (i === 0) {
      steps.push("Preparation");
    } else if (i === totalSteps - 1) {
      steps.push("Finalization");
    } else {
      steps.push(`Round ${i}`);
    }
  }

  return (
    <div className="stepper-container-second">
      <div className="stepper-steps-second">
        {steps.map((step, index) => {
          return (
            <div className="step" key={step}>
              {index < steps.length - 1 && (
                <div
                  className={`step-line ${
                    index < currentStep ? "completed-line" : ""
                  }`}
                ></div>
              )}
              {
                <button
                  className={`step-circle-second
              ${index < currentStep ? "completed" : ""}
              ${index === currentStep ? "step-circle-second-active" : ""}
              ${index !== currentStep ? "clickable-step" : ""}
              `}
                  onClick={() => goToStep(index)}
                ></button>
              }

              <div
                className={`step-label ${
                  index === currentStep ? "active" : ""
                }`}
              >
                {step}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default NegoActionStepper;
